var _style, _defs, _defs2, _path, _path2, _path3, _path4, _path5, _defs3, _path6, _path7, _path8, _defs4, _path9, _path10, _path11, _text, _text2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoFiLvvPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 469.6 91.5",
    style: {
      enableBackground: "new 0 0 410.8 91.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_);}\r\n\t.st1{clip-path:url(#SVGID_4_);fill:#133D8D;}\r\n\t.st2{clip-path:url(#SVGID_4_);fill:#005DAA;}\r\n\t.st3{clip-path:url(#SVGID_4_);}\r\n\t.st4{clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:0.553;}\r\n\t.st5{clip-path:url(#SVGID_6_);fill:#005DAA;}\r\n\t.st6{clip-path:url(#SVGID_6_);fill:#8DC2E9;}\r\n\t.st7{opacity:0.67;clip-path:url(#SVGID_6_);}\r\n\t.st8{clip-path:url(#SVGID_8_);fill:#8DC2E9;}\r\n\t.st9{fill:#133D8D;}\r\n\t.st10{font-family:'ArialMT';}\r\n\t.st11{font-size:20px;}\r\n\t")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 410.8,
    height: 85
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    width: 410.8,
    height: 85
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M306.9,40.3c3.4,0,5.1,3.1,5.1,6.2c0,3.1-1.7,6.2-5.1,6.2c-3.4,0-5.1-3.1-5.1-6.2 C301.8,43.3,303.5,40.3,306.9,40.3 M306.9,38.8c-4.4,0-6.9,3.5-6.9,7.7c0,4.2,2.4,7.7,6.9,7.7c4.4,0,6.9-3.5,6.9-7.7 C313.8,42.3,311.4,38.8,306.9,38.8 M295.3,34.8h-1.8v4.4H291v1.5h2.5v9.9c0,2.5,0.8,3.3,3.1,3.3c0.5,0,1-0.1,1.6-0.1v-1.5 c-0.5,0.1-1,0.1-1.5,0.1c-1.3-0.1-1.4-0.8-1.4-1.9v-9.8h2.9v-1.5h-2.9V34.8z M289.4,43.4c-0.1-3.1-2.4-4.7-5.3-4.7 c-2.6,0-5.4,1.1-5.4,4.1c0,2.5,1.7,3.3,4,3.9l2.3,0.5c1.6,0.4,3.2,1,3.2,2.6c0,2-2.3,2.8-4,2.8c-2.4,0-4.1-1.2-4.3-3.6h-1.8 c0.3,3.5,2.6,5.1,6,5.1c2.7,0,5.8-1.2,5.8-4.4c0-2.5-2.1-3.7-4.1-4l-2.4-0.5c-1.2-0.3-3-0.9-3-2.4c0-1.9,1.9-2.5,3.4-2.5 c2,0,3.7,1,3.8,3.2H289.4z M266,43.6c0.1-2.4,1.7-3.4,3.9-3.4c2.1,0,3.8,0.6,3.8,3c0,1.6-0.8,1.8-2.3,2c-3.8,0.4-7.8,0.6-7.8,4.7 c0,2.9,2.2,4.2,4.9,4.2c2.8,0,4-1.1,5.3-3h0.1c0,1.5,0.3,2.5,2.1,2.5c0.5,0,0.8,0,1.2-0.1v-1.5c-0.1,0.1-0.4,0.1-0.6,0.1 c-0.7,0-1-0.4-1-1.1v-7.7c0-3.9-2.8-4.7-5.3-4.7c-3.3,0-5.7,1.5-5.9,4.9H266z M273.7,48.1c0,2.8-2.4,4.5-5.1,4.5 c-1.7,0-3.2-1.1-3.2-2.9c0-2.8,3.7-2.8,6.7-3.3c0.5-0.1,1.3-0.2,1.5-0.6h0.1V48.1z M255.6,53.7h1.8V46c0-3,2.2-5.4,5.4-5.2V39 c-2.6-0.1-4.6,1.3-5.5,3.6h-0.1v-3.4h-1.6V53.7z M250.4,36.5h1.8v-2.8h-1.8V36.5z M250.4,53.7h1.8V39.2h-1.8V53.7z M241.3,53.7 h1.9l5.4-14.5h-1.8l-4.5,12.7h-0.1l-4.6-12.7h-2L241.3,53.7z M227.9,40.3c3.4,0,5.1,3.1,5.1,6.2c0,3.1-1.7,6.2-5.1,6.2 c-3.4,0-5.1-3.1-5.1-6.2C222.8,43.3,224.5,40.3,227.9,40.3 M227.9,38.8c-4.4,0-6.9,3.5-6.9,7.7c0,4.2,2.4,7.7,6.9,7.7 c4.4,0,6.9-3.5,6.9-7.7C234.7,42.3,232.3,38.8,227.9,38.8 M216.2,34.8h-1.8v4.4h-2.5v1.5h2.5v9.9c0,2.5,0.8,3.3,3.1,3.3 c0.5,0,1-0.1,1.6-0.1v-1.5c-0.5,0.1-1,0.1-1.5,0.1c-1.3-0.1-1.4-0.8-1.4-1.9v-9.8h3v-1.5h-3V34.8z M198.3,53.7h1.8v-8.5 c0.1-2.8,1.7-5,4.5-5c2.9,0,3.7,1.9,3.7,4.4v9h1.8v-9.3c0-3.5-1.2-5.6-5.3-5.6c-2.1,0-4,1.2-4.6,2.9h-0.1v-2.5h-1.8V53.7z  M193.2,36.5h1.8v-2.8h-1.8V36.5z M193.2,53.7h1.8V39.2h-1.8V53.7z M188,53.7h1.8V33.6H188V53.7z M182.8,53.7h1.8V33.6h-1.8V53.7z  M169.8,43.6c0.1-2.4,1.7-3.4,3.9-3.4c2.1,0,3.8,0.6,3.8,3c0,1.6-0.8,1.8-2.3,2c-3.8,0.4-7.8,0.6-7.8,4.7c0,2.9,2.2,4.2,4.9,4.2 c2.8,0,4-1.1,5.3-3h0.1c0,1.5,0.3,2.5,2.1,2.5c0.5,0,0.8,0,1.2-0.1v-1.5c-0.1,0.1-0.4,0.1-0.6,0.1c-0.7,0-1-0.4-1-1.1v-7.7 c0-3.9-2.8-4.7-5.3-4.7c-3.3,0-5.7,1.5-5.9,4.9H169.8z M177.4,48.1c0,2.8-2.4,4.5-5.1,4.5c-1.7,0-3.2-1.1-3.2-2.9 c0-2.8,3.7-2.8,6.7-3.3c0.5-0.1,1.3-0.2,1.5-0.6h0.1V48.1z M153.1,53.7h1.8v-8.5c0.1-2.8,1.7-5,4.6-5c2.9,0,3.7,1.9,3.7,4.4v9h1.8 v-9.3c0-3.5-1.2-5.6-5.3-5.6c-2.1,0-4,1.2-4.6,2.9h-0.1v-8.1h-1.8V53.7z M139.6,45.4c0.3-2.6,1.9-5.2,4.8-5.2 c2.9,0,4.5,2.5,4.6,5.2H139.6z M150.7,46.9c0.1-4.1-1.7-8.1-6.4-8.1c-4.6,0-6.5,3.8-6.5,7.7c0,4.1,1.9,7.7,6.5,7.7 c3.7,0,5.6-1.9,6.3-5.2h-1.8c-0.6,2.2-2,3.7-4.5,3.7c-3.4,0-4.7-3.1-4.8-5.7H150.7z M135.2,39.2h-1.8v7.6c0,2.9-1.3,5.8-4.4,5.8 c-2.8,0-3.8-1.4-3.9-4v-9.4h-1.8v9.4c0,3.4,1.4,5.5,5.1,5.5c2.2,0,4.1-1.1,5-3h0.1v2.6h1.6V39.2z M118.3,53.7h1.8V33.6h-1.8V53.7z  M107.7,35.5l3.9,10.3h-7.9L107.7,35.5z M98.7,53.7h2.1l2.4-6.2h9.1l2.4,6.2h2.1l-7.9-20.1h-2.1L98.7,53.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M9,60.3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M9,60.3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M71.9,12.4"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M71.9,12.4"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    width: 410.8,
    height: 85
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M83.4,16.9c0.6,4.8,0.9,8.6,0.9,14.1c0,6.3-1.2,13.4-6.4,20.4c-9.6,13.2-29.7,14.2-39.6,14 C21.1,65.1,10.7,60,9.1,60.2c0,0-0.1,0-0.1,0c0,0.1-0.8,3.5-1.2,6.2C6.4,74,5.5,83,5.4,85c0,0,0,0,0,0c0.1-0.1,3.8-0.9,9.3-1.7 c5-0.7,11.1-1.1,14.9-1.3c3.8-0.3,8.1-0.4,10.4-0.5C102.3,79.4,83.4,16.9,83.4,16.9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M62.9,11.2c0.1,0,0.2,0.1,0.5,0.2c3,1.8,17.5,13.5-0.6,38.7c0,0,24.5-12.4,9.2-37.4c0,0-1.7-0.5-3.8-0.9 C65.3,11.3,63.3,11.2,62.9,11.2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M69.4,4.6C68.5,4.7,9.8-12.9,1.6,56.4c0,0-11.9-47.4,29.6-55.3C35,0.4,38.7,0,43.9,0C57,0,66.1,3.6,69.4,4.6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    x: 4.5,
    y: 9.6,
    width: 68.5,
    height: 76.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M5.4,85c0,0,0,0,0.1-0.1c1.1-0.8,6.3-4.1,8.7-5.7c4.8-3.3,9.5-7.8,12.3-13.5c11.6-23,10.2-62.8,45.6-53 c0,0-47.8-18.2-63.2,47.8C7,68.5,5.6,82.5,5.4,85"
  })))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M9,60.3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M9,60.3"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 98.7118 85.04)",
    className: "st9 st10 st11"
  }, "Rahanpesun valvontarekisteri")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 50,
    fill: "red",
    fontSize: 30,
    fontFamily: "Arial",
    fontWeight: "bold"
  }, "LVV")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFiLvvPlaceholder);
export default __webpack_public_path__ + "static/media/logo_fi_lvv_placeholder.f788e6409a596cc2fc3fa4de30936c12.svg";
export { ForwardRef as ReactComponent };